import { format } from 'utils/format';
import Chevron from 'assets/icons/chevron-right.svg?react';
import { useTranslation } from 'react-i18next';

export function OriginalAmount({ amount }: { amount?: number }) {
  const { t } = useTranslation();
  return (
    <div
      className="flex flex-col items-center lg:items-start"
      data-test="originalAmount-layout"
    >
      <div className="font-medium" data-test="original-amount-text">
        {t('downsale:prev_amount')}
      </div>
      <div className="text-4xl font-medium" data-test="original-amount">
        {format.number(amount, 'currency')}
      </div>
    </div>
  );
}

export function NewAmount({ amount }: { amount?: number }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center lg:items-start">
      <div
        className="font-medium text-primary"
        data-test="newAmount-proposalAmount-text"
      >
        {t('downsale:proposal_amount')}
      </div>
      <div
        className="text-4xl font-medium text-primary"
        data-test="proposal-amount"
      >
        {format.number(amount, 'currency')}
      </div>
    </div>
  );
}

export default function OriginalAndNewAmount({
  originalAmount,
  newAmount,
}: {
  originalAmount?: number;
  newAmount?: number;
}) {
  return (
    <div className="flex flex-col lg:flex-row items-center gap-1 lg:gap-6">
      <OriginalAmount amount={originalAmount} />
      <Chevron className="rotate-90 lg:rotate-0" />
      <NewAmount amount={newAmount} />
    </div>
  );
}
